'use client'
import { StorageService } from '@dynamic-labs/utils';
import { AUTH_TOKEN, AUTH_MIN_TOKEN } from '../../constants/localStorage.js';
import '../../constants/colors.js';
import '../../constants/values.js';

const storeAuthToken = (jwt, minifiedJwt) => {
    StorageService.setItem(AUTH_TOKEN, jwt, {
        priority: ['secureStorage', 'localStorage'],
    });
    StorageService.setItem(AUTH_MIN_TOKEN, minifiedJwt, {
        priority: ['secureStorage', 'localStorage'],
    });
};

export { storeAuthToken };
